/**
 * Experience Calculation Utility
 * Calculates dynamic business experience from establishment date (13 September 2002).
 */

export const BUSINESS_START_DATE = {
  YEAR: 2002,
  MONTH: 8, // September (0-indexed: 0 = January, 8 = September)
  DAY: 13,
};

/**
 * Calculates the number of completed years of experience from 13 September 2002 to the given date.
 *
 * @param {Date|string|number} [currentDate=new Date()] - The date to calculate experience against (defaults to current date)
 * @returns {number} Completed years of experience
 */
export const calculateExperience = (currentDate = new Date()) => {
  const targetDate = currentDate instanceof Date ? currentDate : new Date(currentDate);

  if (isNaN(targetDate.getTime())) {
    return 0;
  }

  const currentYear = targetDate.getFullYear();
  const currentMonth = targetDate.getMonth(); // 0-indexed
  const currentDay = targetDate.getDate();

  let years = currentYear - BUSINESS_START_DATE.YEAR;

  // Before 13 September of the given year, the current year is not yet completed
  if (
    currentMonth < BUSINESS_START_DATE.MONTH ||
    (currentMonth === BUSINESS_START_DATE.MONTH && currentDay < BUSINESS_START_DATE.DAY)
  ) {
    years -= 1;
  }

  return Math.max(0, years);
};

/**
 * Returns formatted experience text matching the UI design: "{experience}+ Years Experience"
 *
 * @param {Date|string|number} [currentDate=new Date()] - The date to calculate experience against
 * @returns {string} Formatted experience string
 */
export const getExperienceText = (currentDate = new Date()) => {
  return `${calculateExperience(currentDate)}+ Years Experience`;
};
